import * as React from "react";
import { useRef } from "react";
import "../../assets/scss/common/dropdown.scss";
interface IDropdownState {
	listOpen: boolean;
	selectedItem?: any;
}
export interface IDropdownProps {
	headerTitle: React.ReactNode;
	arrow: boolean;
	class?: string;
	listStyle?: string;
	selectItem: boolean;
	listCont?: React.ReactNode;
	listHeader?: string;
	onClickTgl?: boolean; //if false dont show dropdown on click event of dropdown toggle
}

export function Dropdown(props: IDropdownProps) {
	const [ddState, setddState] = React.useState<IDropdownState>({
		listOpen: false,
		selectedItem: ""
	});
	const wrapperRef = useRef(null);

	const useOutsideAlerter = (ref: any) => {
		function handleClickOutside(event: Event) {
			if (ref.current && !ref.current.contains(event.target)) {
				setddState({
					listOpen: false
				});
			}
		}

		React.useEffect(() => {
			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside);
			};
		});
	};

	useOutsideAlerter(wrapperRef);

	const toggleList = () => {
		//if onClickTgl prop is true or undefined(not sent as prop) show
		//dropdown on click event of dropdown toggle
		if (props.onClickTgl || props.onClickTgl === undefined) {
			setddState({
				listOpen: !ddState.listOpen
			});
		}
	};

	return (
		<div className={"dd-wrapper " + props.class + (ddState.listOpen ? " open" : "")} ref={wrapperRef}>
			<div className="dd-header" onClick={() => toggleList()}>
				<>{ddState.selectedItem ? ddState.selectedItem.text : props.headerTitle}</>
				{props.arrow && (ddState.listOpen ? <i className="edel-icon-caret-up"></i> : <i className="edel-icon-caret-down"></i>)}
			</div>

			<div className={"ddListContainer"}>{props.listCont}</div>
		</div>
	);
}

export default Dropdown;
